import { Component } from '@angular/core';
import { AdministratorFacade, SharedFacade } from '@piqet-angular/data';
import { CustomModalService, SearchModel } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { LoginLogsGridService } from 'libs/features/src/lib/layout/administrator/user-managment/login-logs/login-logs-data-grid.service';

@Component({
  selector: 'piqet-angular-admin-login-logs-history',
  templateUrl: './admin-login-logs-history.component.html',
  styleUrls: ['./admin-login-logs-history.component.scss'],
})
export class AdminLoginLogsHistoryComponent {
  processColumnDef: any;
  modalLabel: any;
  loginLogsHistory: any;
  isMaximize = false;
  isSearchInputPosition = false;
  userId: any;
  userName: any;

  totalCount = 0;
  pageNumber = 1;
  pageSize = 10;
  searchText = '';
  sortColumn = 'logindate';
  sortOrder = 'DESC';
  cache: { [key: string]: any[] } = {};
  searchSubject = new Subject<string>();
  sortColumnMap: { [key: string]: string } = {
    LoginDate: 'logindate',
    LoginTime: 'logintime',
    Ipaddress: 'ipaddress',
  };

  constructor(
    private modal: CustomModalService,
    public AdministratroFacade: AdministratorFacade,
    private loginLogsDataGridService: LoginLogsGridService,
    private sharedFacade: SharedFacade,
    private administratorService: AdministratorService
  ) {
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.userId = this.modal?.modalService?.config?.initialState?.['userId'];
    this.userName = this.modal?.modalService?.config?.initialState?.['userName'];
  }

  ngOnInit(): void {
    this.getLoginHistory();
    this.initializeSearch();
  }

  async getLoginHistory() {
    const payload = new SearchModel();
    payload.userId = this.userId;
    payload.pageNumber = this.pageNumber;
    payload.pageSize = this.pageSize;
    payload.search = this.searchText;
    payload.sortColumn = this.sortColumn;
    payload.sortOrder = this.sortOrder;
    const res: any = await this.administratorService.getLoginHistory(payload);
    this.loginLogsHistory = res.data?.loginLogList;
    this.totalCount = res.data?.totalCount ?? 0;
    this.userName = res.data?.userName ?? this.userName;
  }

  async paginationChanged(event: any) {
    const newPageSize = event.pageSize;
    const goToPage = event.goToPage;

    if (this.pageSize !== newPageSize) {
      this.pageSize = newPageSize;
      this.pageNumber = 1;
      this.cache = {};
    }

    const cacheKey = `${this.pageSize}_${this.searchText}_${goToPage}`;
    if (this.cache[cacheKey]) {
      this.loginLogsHistory = this.cache[cacheKey];
    } else {
      const payload = new SearchModel();
      payload.userId = this.userId;
      payload.pageNumber = goToPage;
      payload.pageSize = this.pageSize;
      payload.search = this.searchText;
      payload.sortColumn = this.sortColumn;
      payload.sortOrder = this.sortOrder;
      const res: any = await this.administratorService.getLoginHistory(payload);
      this.cache[cacheKey] = res.data?.loginLogList;
      this.loginLogsHistory = this.cache[cacheKey];
      this.totalCount = res.data?.totalCount ?? 0;
    }

    this.pageNumber = goToPage;
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(query => {
          this.pageNumber = 1;
          this.cache = {};
          const payload = new SearchModel();
          payload.userId = this.userId;
          payload.pageNumber = this.pageNumber;
          payload.pageSize = this.pageSize;
          payload.search = query;
          payload.sortColumn = this.sortColumn;
          payload.sortOrder = this.sortOrder;
          return this.administratorService.getLoginHistory(payload);
        })
      )
      .subscribe({
        next: (res: any) => {
          this.loginLogsHistory = res.data?.loginLogList;
          this.totalCount = res.data?.totalCount ?? 0;
        },
        error: error => console.error('Error fetching login history:', error),
      });
  }

  searchRecord(event: any) {
    const query = event?.trim() ?? '';
    this.searchText = query;
    this.searchSubject.next(query);
  }

  async sortChanged(sortColumnState: { columnName: string; dir: string }) {
    this.sortColumn = this.sortColumnMap[sortColumnState.columnName] ?? 'logindate';
    this.sortOrder = sortColumnState.dir?.toUpperCase() ?? 'DESC';
    this.pageNumber = 1;
    this.cache = {};

    const payload = new SearchModel();
    payload.userId = this.userId;
    payload.pageNumber = this.pageNumber;
    payload.pageSize = this.pageSize;
    payload.search = this.searchText;
    payload.sortColumn = this.sortColumn;
    payload.sortOrder = this.sortOrder;
    const res: any = await this.administratorService.getLoginHistory(payload);
    this.loginLogsHistory = res.data?.loginLogList;
    this.totalCount = res.data?.totalCount ?? 0;
  }

  onClose() {
    this.modal.close();
  }
}
